/**
 * WHAT THE CUSTOMER SEES OF EACH ROOM. Jacky, 18 Oct 2026: *"not in scope = don't show data on proposal either"*.
 * Rosie Prom's released copy listed Bed 1, Bed 2, L'dry, Bath and the balcony with their m² beside the four rooms
 * actually quoted. An out-of-scope room keeps its grey outline on the plan (where the work is, in context) but shows
 * no area, finish or site dimension.
 */
export type ScopeRoom = {id: string; name: string; finish: string | null; in_proposal?: boolean; out_of_scope: boolean; is_void: boolean};
export type ScopeLine = {room: string};

export const roomIncluded = (r: ScopeRoom) => (r.in_proposal ?? !!r.finish) && !r.out_of_scope && !r.is_void;

/** The quoted rooms, and only the site dimensions taken in them (a line names its room by name or id). */
export function scopedPlan<R extends ScopeRoom, L extends ScopeLine>(rooms: R[], lines: L[] = []) {
  const quoted = rooms.filter(roomIncluded);
  const keys = new Set(quoted.flatMap((r) => [r.name, r.id]));
  return {rooms: quoted, lines: lines.filter((l) => keys.has(l.room))};
}
